import { render, staticRenderFns } from "./CategoryDialog.vue?vue&type=template&id=77963e8c&scoped=true&"
import script from "./CategoryDialog.vue?vue&type=script&lang=ts&"
export * from "./CategoryDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77963e8c",
  null
  
)

export default component.exports